<template>
  <svg viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M4.5 9.6665H15.5C16.2293 9.6665 16.9288 9.9299 17.4445 10.3987C17.9603 10.8676 18.25 11.5035 18.25 12.1665C18.25 12.8295 17.9603 13.4654 17.4445 13.9343C16.9288 14.4031 16.2293 14.6665 15.5 14.6665H4.5C3.77065 14.6665 3.07118 14.4031 2.55546 13.9343C2.03973 13.4654 1.75 12.8295 1.75 12.1665C1.75 11.5035 2.03973 10.8676 2.55546 10.3987C3.07118 9.9299 3.77065 9.6665 4.5 9.6665Z"
      stroke-width="2"
      :class="containerClass"
    />
    <path
      d="M1.75 12.1666C1.75 10.9916 3.11675 6.08825 3.9225 3.29825C4.12417 2.60242 4.225 2.25492 4.44683 1.98992C4.64117 1.75825 4.90517 1.57325 5.20125 1.46075C5.5395 1.33325 5.93917 1.33325 6.74125 1.33325H13.2588C14.0608 1.33325 14.4605 1.33325 14.7988 1.46075C15.0948 1.57325 15.3588 1.75825 15.5532 1.98992C15.775 2.25492 15.8758 2.60242 16.0766 3.29825C16.8842 6.08825 18.25 10.9916 18.25 12.1666"
      stroke-width="2"
      :class="containerClass"
    />
    <path
      d="M16.4166 12.1666C16.4166 11.7063 16.0062 11.3333 15.5 11.3333C14.9937 11.3333 14.5833 11.7063 14.5833 12.1666C14.5833 12.6268 14.9937 12.9999 15.5 12.9999C16.0062 12.9999 16.4166 12.6268 16.4166 12.1666Z"
      :class="containerClass"
    />
    <path
      d="M6.33331 11.3333H4.49998C3.99372 11.3333 3.58331 11.7063 3.58331 12.1666C3.58331 12.6268 3.99372 12.9999 4.49998 12.9999H6.33331C6.83957 12.9999 7.24998 12.6268 7.24998 12.1666C7.24998 11.7063 6.83957 11.3333 6.33331 11.3333Z"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
